module.exports = __webpack_public_path__ + "static/bride-bicycle-c01e8bb49afe02cd3248cd661cdfe5d0.svg";